import { render } from "./PaperVideoSteps.vue?vue&type=template&id=6fabf752"
import script from "./PaperVideoSteps.vue?vue&type=script&lang=js"
export * from "./PaperVideoSteps.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__